import { render, staticRenderFns } from "./BarChartWrapper.vue?vue&type=template&id=eff40a3e&"
import script from "./BarChartWrapper.vue?vue&type=script&lang=js&"
export * from "./BarChartWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports